import { render, staticRenderFns } from "./group.vue?vue&type=template&id=8b6a6194&scoped=true"
var script = {}
import style0 from "./group.vue?vue&type=style&index=0&id=8b6a6194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6a6194",
  null
  
)

export default component.exports